module.exports = __webpack_public_path__ + "static/media/izettle-logo.9ec8a9f1.png";